<template>
  <div class="home flex items-center flex-col">
    <div v-if="categories !== false" class="flex flex-row w-1/2 justify-between flex-wrap">
      <div class="font-thin m-2 py-1 px-1  flex flex-row items-center bg-gradient-to-r from-blue-300 to-blue-200 rounded-lg text-blue-900 text-sm shadow-lg shadow-blue-200 border-2 border-blue-500 hover:bg-blue-500 hover:shadow-2xl transition-all duration-300 ring-offset-2 focus:ring-2 focus:ring-blue-400">
        <input v-model="newCategory" class= "bg-transparent w-full" placeholder="+ Category" @keyup.enter="addCategory(newCategory)"/>
      </div>
      <category-button v-for="category in categories" :key="category.id" :id="category.id" :text="category.title"/>
    </div>
    <div v-else>
      LOADING
    </div>
    <div v-if="todos.length==0" class="m-5">
      You haven't accomplished anything...
    </div>
    <div v-else-if="todos !== false" class="w-full flex items-center flex-col" >
      <ToDoItem v-for="todo in sorted_todos" :isDone="true" :key="todo.id" :id="todo.id" :text="todo.content" @checked="removeTodo(todo.id)" />
    </div>
    <div v-else>
      LOADING
    </div>
  </div>
</template>

<script>
import ToDoItem from '@/components/ToDoItem.vue'
import { auth, db } from "@/firebaseConfig";
import CategoryButton from '../components/CategoryButton.vue';



export default {
  name: 'DoneView',
  components: {
    ToDoItem,
    CategoryButton
  },
  data () {
    return {
      todos: false,
      categories: false,
      user: null
    }
  },
  
  beforeCreate: function() {
    auth.onAuthStateChanged((user) => {
      console.log("user state:", user);
      this.user = user
      if (!user) {        
        this.$router.push('/')
      }
    });
    
  },
  methods: {
    addCategory(title) {
      this.currentlyAdding = true
      if(!this.user) {
        console.error('no user!!!')
        return undefined
      }
      let newCategory = {
          user: auth.currentUser.uid,
          title: title
      }
      this.newCategory = ""
      db.collection('categories').add(newCategory).then( () => {
        this.currentlyAdding = false
      });
      
    },
    todoInDepth(todo) {
      var id = todo.id
      this.$router.push(`/todo:${id}`)
    },
    removeTodo(todo) {
      this.todos = this.todos.filter(t => t.id !== todo)
    }
  },
  firestore: function() {
    return { 
        todos: db.collection('todos').where('user', '==', auth.currentUser.uid).where('doneBool', '==', true),
        categories: db.collection('categories').where('user', '==', auth.currentUser.uid)

    }
  },
  computed: {
      sorted_todos() {
          let sorted_todos = [...this.todos];
          if (sorted_todos === false) {
              return false 
          } else {
              sorted_todos.sort((doc1,doc2) => doc1.created.seconds - doc2.created.seconds)
              return sorted_todos
          }
      }
  }
}
</script>

<style scoped>

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: white;
}

</style>
